import CallToAction from '../components/sections/CallToAction';
import Footer from '../components/Footer';
import VideoSection from '../components/sections/VideoSection';
import TestimonalSection from '../components/sections/TestimonialSection';
import BookingSection from '../components/sections/BookingSection';

// import AboutSection from '../components/sections/AboutSection';
// import HeroSection from '../components/sections/HeroSection';
// import TeamSection from '../components/sections/TeamSection';

function BookMeeting() {
  return (
    <>
      {/* <HeroSection /> */}
      <VideoSection isHeroSection={true} customBackground="#ffffff" />
      <CallToAction scrollToBooking={true} />
      <TestimonalSection customBackground="hsl(0, 14%, 98%)" />
      <BookingSection />
      {/* <AboutSection /> */}
      {/* <TeamSection /> */}
      <Footer isGray={false} />
    </>
  );
}

export default BookMeeting;
